import React from 'react'
import TemplateSelect from '~/components/Common/TemplateSelect'
import { IPropertyInput } from '../../types'

const TemplateField = ({
  property,
  value,
  setFieldValue,
  isError,
}: IPropertyInput) => {
  const { name, defaultValue } = property

  const handleChange = ({ value }) => {
    setFieldValue(name, value)
  }

  return (
    <TemplateSelect
      template={value}
      placeholder={defaultValue}
      onChange={handleChange}
      isError={isError}
    />
  )
}

export default TemplateField
